import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import TypeUserApi from '../api/type_user/type_user.ts';

export const fetchDataTypeUserAsync = createAsyncThunk(
    'typeUser/fetchTypeUser',
    async () => {
        const response = await TypeUserApi();
        return response.data;
    }
);

const typeUserSlice = createSlice({
    name: 'typeUser',
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchDataTypeUserAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchDataTypeUserAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchDataTypeUserAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default typeUserSlice.reducer;